import styled from 'styled-components';
import { flexCenter } from '../../helpers/style-helpers';

type TLoadingOverlaySC = {
  isLoading: boolean;
  background?: 'GREY' | 'WHITE' | 'COMPLETE_WHITE';
};
export const LoadingOverlaySC = styled.div<TLoadingOverlaySC>`
  position: relative;
  overflow: hidden;

  .loading-blured {
    ${({ isLoading }) => (isLoading ? 'filter: blur(5px);' : '')}
  }

  .loading-overlay {
    ${flexCenter}

    flex-direction: column;
    position: absolute;
    inset: 0;
    background: ${({ background }) =>
      background === 'GREY'
        ? 'rgba(255, 255, 255, 0.6)'
        : 'COMPLETE_WHITE'
        ? '#FFFFFF'
        : 'rgba(255, 255, 255, 0.6)'};
  }

  .loading-overlay-text {
    font-weight: 200;
    font-size: 29px;
    line-height: 40px;
    margin-bottom: 10px;
    color: #293157;
  }
`;
